<template>
  <div>
    <h1 class="header">Upload file:</h1>
    <div class="dropbox">
      <template v-if="isInitial">
        <input type="file" accept="files/*" class="input-file" @change="onUpload" />
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 24 24" width="48"><path d="M0 0h24v24H0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" fill="#43425d"/></svg>
        <p>
          Drag your file here to begin<br />
          or click to browse
        </p>
      </template>
      <div class="uploaded">
        <template v-if="isSaving">
          <progress id="progress" :value="uploadValue" max="100" :label="uploadValue.toFixed() + '%'"></progress>
        </template>
        <div v-if="file != null">
          <div class="preview">
            <a :href="url">{{ file.name }}</a>
            <!-- prettier-ignore -->
            <svg @click="removeFile" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#a3a6b4" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
export default {
  data() {
    return {
      file: null,
      fileName: '',
      url: null,
      uploadValue: 0,
      isSaving: false,
      isInitial: true,
    }
  },
  methods: {
    onUpload(event) {
      this.isSaving = true
      this.isInitial = false
      this.uploadValue = 0
      this.file = event.target.files[0]
      this.fileName = `${moment().format()}-${this.file.name}`

      const storageRef = firebase
        .storage()
        .ref()
        .child(`task-templates/${this.fileName}`)
        .put(this.file)

      storageRef.on(
        `state_changed`,
        snapshot => {
          this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        },
        error => {
          console.log(error.message)
        },
        () => {
          this.uploadValue = 100
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            this.url = url
            this.$emit('uploaded', url)
          })
        }
      )
    },
    removeFile() {
      const storageRef = firebase
        .storage()
        .ref()
        .child(`task-templates/${this.fileName}`)
        .delete()
      this.$emit('uploaded', null)

      this.file = null
      this.isInitial = true
      this.isSaving = false
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';

.header {
  font-size: 0.8rem;
  margin-bottom: 1em;
}

.dropbox {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 2rem;
  border-radius: 0.5rem;
  border: 1px dashed #e9e9f0;
  background-color: #fafafc;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: inherit;
  color: #a3a6b4;
  height: 250px;
}

.input-file {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  top: 0;
  top: 0px;
  bottom: 0px;
  width: 100%;
}

.dropbox:hover {
  background: #a39ffb15; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1em;
  text-align: center;
}

.uploaded {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview {
  display: flex;
  align-items: center;
  margin-top: 0.5em;
}
.preview > a {
  color: #a3a6b4;
  text-decoration: none;
}
.preview > a:hover {
  color: var(--color-state);
}
.preview > svg {
  margin-left: 0.5rem;
  cursor: pointer;
}
.preview > svg:hover {
  fill: var(--color-state);
}

progress {
  position: relative;
  border-radius: var(--border-radius-large);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  height: 24px;
}
progress:before {
  content: attr(label);
  font-size: 0.8em;
  font-weight: 400;
  color: white;
  vertical-align: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
progress::-webkit-progress-bar {
  background-color: white;
  border-radius: var(--border-radius-large);
}
progress::-webkit-progress-value {
  background-color: var(--color-state);
  border-radius: var(--border-radius-large);
}
</style>
